'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _lifecycle = require('recompose/lifecycle');

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _mapProps = require('recompose/mapProps');

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var expandable = function expandable() {
    return (0, _compose2.default)((0, _withState2.default)('isExpanded', 'setExpanded', function (_ref) {
        var _ref$expanded = _ref.expanded,
            expanded = _ref$expanded === undefined ? false : _ref$expanded;
        return Boolean(expanded);
    }), (0, _lifecycle2.default)({
        componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
            if (nextProps.expanded !== this.props.expanded) {
                this.props.setExpanded(nextProps.expanded);
            }
        }
    }),
    // Filter `expanded` from the forwarded props. It is replaced by the `isExpanded`-prop.
    // Also, transform `setExpanded` into an `onToggleExpanded` event handler
    // eslint-disable-next-line no-unused-vars
    (0, _mapProps2.default)(function (_ref2) {
        var expanded = _ref2.expanded,
            setExpanded = _ref2.setExpanded,
            interaction = _ref2.interaction,
            ownerProps = (0, _objectWithoutProperties3.default)(_ref2, ['expanded', 'setExpanded', 'interaction']);
        return (0, _extends3.default)({
            interaction: interaction
        }, ownerProps, {
            onToggleExpanded: function onToggleExpanded() {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                interaction({ elementName: 'expandableElement', args: args });
                return setExpanded(function (isExpanded) {
                    return !isExpanded;
                });
            }
        });
    }));
};

exports.default = expandable;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/hoc-expandable/lib/cjs/index.js
 ** module id = 500
 ** module chunks = 1
 **/